/// <reference types="@types/googlemaps" />
declare function CallTrack_function(page,RepName,ProductName,terms, usage500, usageObj1000, usage2000, zipcode, utility_name,enrollmentStatus,Email): void;
import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  NgZone,
  Input,
  Output,
  EventEmitter,
  AfterViewInit,
  Renderer2,
} from '@angular/core';
import { _ } from 'underscore';
declare var google: any;
import { HttpClient, HttpParams } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';
import { MapsAPILoader } from '@agm/core';
import { GooglePlaceDirective } from 'ngx-google-places-autocomplete/ngx-google-places-autocomplete.directive';
import { ResidentialService } from '../residential.service';
import { RecommendationService } from '../recommendation/recommendation.service';
import { environment } from '../../../../environments/environment';
import { states } from '../../../../assets/js/states';
import { UserSettingsService } from '../../../user-settings/user-settings.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import * as Highcharts from 'highcharts';
declare var $;
import { PlatformLocation } from '@angular/common';
Highcharts.setOptions({ lang: { thousandsSep: ',' } });
@Component({
  selector: 'app-signup-order',
  templateUrl: './signup-order.component.html',
  styleUrls: ['./signup-order.component.css'],
})
export class SignupOrderComponent implements OnInit, AfterViewInit {
  @Input() data: any;
  @Output() selectOn: EventEmitter<any> = new EventEmitter();
  @ViewChild('places', { static: true }) places: GooglePlaceDirective;
  @ViewChild('search', { static: true }) public searchElement: ElementRef;
  @ViewChild('template', { static: true }) template: ElementRef;
  @ViewChild('noservice', { static: true }) noService: ElementRef;
  @ViewChild('contact', { static: true }) contact: ElementRef;
  @ViewChild('thank', { static: true }) thank: ElementRef;
  @ViewChild('conf_email', { static: true }) conf_email: ElementRef;
  @ViewChild('newEnergyRates', { static: true }) newEnergyRates: ElementRef;
  @ViewChild('invalidUtility', { static: true }) invalidUtility: ElementRef;
 @ViewChild('invalidESIID', { static: true }) invalidESIID: ElementRef;
invalidESIIDText
UtilityText
UtilityNumber
  url = environment.api_url;
  apartment = '';
  selectedAddress = '';
  address;
  formatedAddress;
  question;
  questions;
  userResponses = [];
  index;
  averagePrice;
  selectedProduct;
  t1_avg_charge;
  t2_avg_charge;
  t3_avg_charge;
  avgMthlyUsage;
  avgbill;
  disableTab = true;
  ServiceCompWeb = false;
  confirmDisable = false;
  enrollmentDisable = true;
  serviceDisablee = true;
  startDate;
  billingAddress = false;
  street_address;
  apt;
  billingState = true;
  state = 'TX';
  city;
  zipcode;
  billing_address;
  statesArr;
  validateBillingAddress = false;
  validateEsiid = false;
  ngClass = false;
  disableButton = true;
  showInvoice = false;
  showCredits = '';

  componentForm = {
    street_number: 'short_name',
    route: 'long_name',
    locality: 'long_name',
    administrative_area_level_1: 'short_name',
    country: 'long_name',
    postal_code: 'short_name',
  };

  esiidResponses: any = [];
  esiidTDSPIndicator: any = [];
  esiidTSWitchHold: any = [];
  selectedEsiid;
  lookUpEsiID;
  singleEsiid = false;
  isMobileView = false;

  //help pop-up
  userObj = {
    fullName: '',
    emailId: '',
    contactQues: '',
    type: 'contact',
  };
  // Save contact
  contactObj = {
    fullName: '',
    emailId: '',
    question: '',
  };
  display = 'none';

  // For ngx-google-autocomplete
  lat;
  lng;
  options = {
    // types: [],
    types: ['address'],
    componentRestrictions: { country: 'US' },
  };
  isAddressSelected = false;
  geoMapAddress;
  deviceWidth;
  orderDetails = false;
  showService = false;
  disabled = true;
  oldAddress;
  oldApartment;
  home_address;
  esiid_value;
  switchType;

  // To show the component based on width(mobile view)
  showServiceComp = false;
  showEnrollmentComp = false;

  utilities;
  selectedUtility;
  modalRef: BsModalRef;
  zip_code;
  callUtilityAPI = false;
  temperaryUtility;
  showMsg = false;
  modalVisible = false;
  msg;
  fullText = false;
  partialText = true;
  showHelp = false;
  enableESIDInput = false;
  esiid1;
  isAddressChanged = true;
  newformateAddress;
  ChangedformatedAddress;
  nextButtonFlag = false;
  confirmFlag = false;
  serviceTypeResultList: string;
  selectedProductLogos = {
    ChariotEnergy: 'Chariot Energy Logo',
    PulsePower: 'Pulse Power Logo',
  };
  providerContact: any;
  private loadTdspNameForEsiid = [
    { key: 1044372, value: 'Oncor' },
    { key: 1040051, value: 'TNMP' },
    { key: 1008901, value: 'CenterPoint' },
    { key: 1020404, value: 'AEPN' },
    { key: 1003278, value: 'AEPC' },
    { key: 1017008, value: 'LPL' },
    { key: 1011292, value: 'LPL' }
  ];
  private actualUtilityName = {
    AEPTexasCentral: 'AEPC',
    AEPTexasNorth: 'AEPN',
    TexasNewMexicoPower: 'TNMP',
    CenterPointEnergy: 'CenterPoint',
    Oncor: 'Oncor',
    CenterPoint : 'CenterPoint',
    LubbockPowerandLight :'LPL'
  };
  selectedChange: boolean;
  oldZipCode: any;
  newFormattedAddress: any;
  navigatorBrowser: string;
  houseAddress2: string;
  houseAddress1: any;
  showAll: boolean = false;
  productKeyTitle: string;
  productTitle: any;
  avgCharge500: string;
  avgCharge1000: string;
  avgCharge2000: string;
  recommendedEnergyCharge: any;
  recommendedBaseFee: any;
  recommendedBaseUsageLimit: any;
  recommendedTduCharge: string;
  recommendedTduDeliveryCharge: any;
  averageMonthlyUsage: any;
  avgPricePerKWH: string;
  avgMonthlyBill: any;
  recommendedUsageCreditFee: any;
  recommendedUsageCreditLimit: string;
  monthlyEstimates: string[];
  singleObj: any;
  toggleHighcharts: boolean = false;
  Highcharts = Highcharts;
  highChartsOptions;
  DELAY = 700;
  clicks = 0;
  timer = null;
  showDetal = false;
  recommendationObj;
  recommendProduct;
  splitData = [];
  chart;
  graphSelectedProduct: any;
  productIndex: number;
  recommendations: any;
  monthlyUsageArr: any;
  avg_price_kwh: any;
  oldValue: any;
  showOption: any;
  updateProductChart = false;
  newValue: any;
  selectedIndex: number;
  monthName: any;
  updatedNewValue: any;
  updateValue: boolean;
  pointWidth: any;
  graaphLabelName: any;
  visibleGraph: any;
  Math: any;
  math: Math;
  constructor(
    private http: HttpClient,
    private residentialService: ResidentialService,
    private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone,
    private recommendationService: RecommendationService,
    private router: Router,
    private userSettingsService: UserSettingsService,
    private modalService: BsModalService,
    private _renderer2: Renderer2,
  ) {
    if (
      this.recommendationService &&
      this.recommendationService.signupProduct
    ) {
      this.selectedProduct = this.recommendationService.signupProduct;
      sessionStorage.setItem(
        'signupProduct',
        JSON.stringify(this.selectedProduct)
      );
    } else {
      this.selectedProduct = JSON.parse(
        sessionStorage.getItem('signupProduct')
      );
      this.recommendationService.signupProduct = this.selectedProduct;
    }
    this.questions = this.residentialService.getQues();
    if (
      _.isEmpty(this.residentialService.user) &&
      !_.isEmpty(sessionStorage.getItem('userObj'))
    ) {
      const userObj = JSON.parse(sessionStorage.getItem('userObj'));
      this.residentialService.setUser({
        userName: userObj.userName,
        accountId: userObj._id,
      });
    } else if (
      _.isEmpty(this.residentialService.user) &&
      _.isEmpty(sessionStorage.getItem('userObj'))
    ) {
      const hg_accountId = window.location.href.split('/').pop();
      const userName = localStorage.getItem('userName');
      this.residentialService.setUser({
        userName: userName,
        accountId: hg_accountId,
      });
    }
    if (this.esiidResponses.length > 0) {
      this.selectedEsiid = this.esiidResponses[0];
      this.esiid_value = this.selectedEsiid;
    }
    //Dynamically assigning service type values as per selection
    this.residentialService.dataString$.subscribe((resultList) => {
      this.serviceTypeResultList = resultList;
      this.switchType = this.serviceTypeResultList;
    });

    this.residentialService.switchDataString$.subscribe((res: any) => {
      this.startDate = res;
    });
    //End
    // addded the below for add address flow - As we are not getting the userresponse from service
    if (!_.isEmpty(sessionStorage.getItem('userResponse')) && sessionStorage.getItem('userResponse') != null) {
      this.userResponses = JSON.parse(
        sessionStorage.getItem('userResponse')
      ).userResponses;
    }
    if (this.residentialService.userResponse === null) {
      this.residentialService.userResponse = {
        userResponses: [],
      };
      this.residentialService.userResponse['userResponses'] =
        this.userResponses;
    }

    if (_.isEmpty(this.userResponses)) {
      const responses = JSON.parse(sessionStorage.getItem('userResponses'));
      this.userResponses = responses;
      this.residentialService.userResponse['userResponses'] =
        this.userResponses;
    }
    if (!_.isEmpty(this.userResponses)) {
      const switchObj = _.findWhere(this.userResponses, {
        res_question_id: '002',
      });
      this.switchType = switchObj.fieldValue;
      if (this.switchType === 'New Service') {
        const switchDateObj = _.findWhere(this.userResponses, {
          res_question_id: '007',
        });
        if (!_.isEmpty(switchDateObj)) {
          if (
            switchDateObj.startDateType &&
            switchDateObj.startDateType === 'Priority Move-In'
          ) {
            this.startDate = 'Priority Move-In';
          } else {
            const someDate = new Date();
            const numberOfDaysToAdd = 2;
            someDate.setDate(someDate.getDate() + numberOfDaysToAdd);
            if (new Date(switchDateObj.fieldValue) < someDate) {
              this.startDate = 'Priority Move-In';
            } else {
              this.startDate = switchDateObj.fieldValue;
              if (sessionStorage.getItem('selectdSwitchDate')) {
                this.startDate = sessionStorage.getItem('selectdSwitchDate');
              }
              this.navigatorBrowser = this.residentialService.myBrowser();
              if (this.navigatorBrowser === 'Safari') {
                const start = this.formatStartDateForSafari();
              }
              sessionStorage.setItem('defaultSwitchDate', this.startDate);
            }
          }
        }
      } else {
        const obj = _.findWhere(this.userResponses, { res_question_id: '004' });
        if (obj.fieldValue === 'Standard Switch') {
          this.startDate = 'Standard Switch';
        } else {
          const dateObj = _.findWhere(this.userResponses, {
            res_question_id: '005',
          });
          this.startDate = dateObj.fieldValue;
          if (sessionStorage.getItem('selectdSwitchDate')) {
            this.startDate = sessionStorage.getItem('selectdSwitchDate');
          }
        }
      }
    }
    this.deviceWidth = this.residentialService.deviceWidth;
    this.averagePrice =
      Number(this.selectedProduct.new_tier.ave_price_per_KWH) * 100;
    this.t1_avg_charge = (
      Number(this.selectedProduct.tier[0].avg_charge) * 100
    ).toFixed(1);
    this.t2_avg_charge = (
      Number(this.selectedProduct.tier[1].avg_charge) * 100
    ).toFixed(1);
    this.t3_avg_charge = (
      Number(this.selectedProduct.tier[2].avg_charge) * 100
    ).toFixed(1);
    this.avgMthlyUsage = Math.round(
      this.selectedProduct.new_tier.ave_monthly_usage
    );
    this.avgbill = Math.round(this.selectedProduct.new_tier.ave_monthly_bill);
    this.statesArr = Object.keys(states);
  }

  formatStartDateForSafari() {
    const startDate = this.startDate.split(' ')[0].split('-');
    return startDate[1] + startDate[2] + startDate[0];
  }
  ngOnInit() {

    if($('#autocomplete').text() == "")
    {
      this.change();
      $('#autocomplete').attr('placeholder','Enter Service Address and Select From Dropdown Below');
    
    }
    this.loadScript();
    const autocomplete = new google.maps.places.Autocomplete(
      document.getElementById('autocomplete'),
      { types: ['geocode'] }


    );
    google.maps.event.addListener(autocomplete, 'place_changed', () => {
      this.selectOn.emit(
        this.getFormattedAddress(autocomplete.getPlace())
      );
    });
  

    this.residentialService.widthoutQuestionUserRequest = JSON.parse(sessionStorage.getItem('widthoutQuestionUserRequest'));

    // Adding this for gmail/fb signup user -> in direct case we dont get userObj from localstorage -> to set the value
    this.userSettingsService.getHgUserObj();
    sessionStorage.setItem('percentage',JSON.stringify(100));
    this.recommendationService.hg_accountId = this.userSettingsService.hg_accountId;
    this.getProviderInfo();
    if (
      (this.userResponses && this.userResponses.length === 0) ||
      this.residentialService.questionFlowType === 'renewal'
    ) {
      const serviceAddress = JSON.parse(
        sessionStorage.getItem('formateAddress')
      ).formatedAddress;

      if (serviceAddress !== null) {
        this.formatedAddress = serviceAddress;
        this.home_address = serviceAddress;
      }
    }
    if (this.userResponses != null && this.userResponses.length > 0) {
      const obj = _.findWhere(this.userResponses, { res_question_id: '008' });
      if (!_.isEmpty(obj)) {
        sessionStorage.setItem(
          'formateAddress',
          obj.fieldValue.formatedAddress
        );
        this.callUtilityAPI = true;
        this.address = obj.fieldValue.address;
        this.oldAddress = obj.fieldValue.formatedAddress;
        this.apartment = obj.fieldValue.apartment;
        this.oldApartment = this.apartment;
        this.formatedAddress = obj.fieldValue.formatedAddress;
        this.geoMapAddress = obj.fieldValue.geoMapAddress;
        this.selectedUtility = obj.fieldValue.utility;
        this.onhandleAddressChange(this.geoMapAddress);
        this.oldZipCode = this.zip_code;
      }
      if (
        this.apartment != null &&
        this.apartment != undefined &&
        this.apartment != ''
      ) {
        this.ChangedformatedAddress =
          this.formatedAddress.split(',')[0] +
          ' APT ' +
          this.apartment +
          ',' +
          this.formatedAddress.split(',')[1] +
          ',' +
          this.formatedAddress.split(',')[2];
      } else {
        this.ChangedformatedAddress = this.formatedAddress;
      }
    }else
    {
      this.selectedUtility = this.residentialService.widthoutQuestionUserRequest["utilityName"];
    }

    this.orderDetails = document
      .getElementById('confirm')
      .classList.contains('active')
      ? false
      : true;
    this.residentialService.setShowService.subscribe((data) => {
      this.showService = data.flag;
      this.showEnrollmentComp = data.showEnrollmentComp
        ? data.showEnrollmentComp
        : false;
    });

    // To load the component based on mobile width
    this.deviceWidth = window.innerWidth;
    if (this.deviceWidth > 768) {
    } else {
      this.isMobileView = true;
    }

    // Remove the scroll initial
    setTimeout(() => {
      const letsgoScroll = document.getElementsByTagName('html');
      if (letsgoScroll[0].classList.contains('letsgo')) {
        letsgoScroll[0].classList.remove('letsgo');
      }
    }, 30);

    const confirmTabValue = document.getElementById('confirm_click');
    confirmTabValue.classList.add('active');
    confirmTabValue.classList.add('nav-link');

    if (sessionStorage.getItem('creditCheckFailed')) {
      this.loadSignUpOrderTabs();
    }
    this.beforeUnloadHandler();
    if(sessionStorage.getItem('recommendationsSelected') != 'undefined')
    {
      this.residentialService.recommendations = JSON.parse(
        sessionStorage.getItem('recommendationsSelected')
      );
    }
   
      this.changeIUsageGraphbyProduct(this.selectedProduct);



      var id = this.recommendationService.hg_accountId;
      $(window).on('popstate', function (event) {

          if (this.isMobileView = true) {

              location.href = '/recommendation/compare-product/' + id;

              // this.location.pushState("forward",null,"/recommendation/compare-product"+
              // this.recommendationService.hg_accountId)

          }


      });


      if($('#autocomplete').text() == "")
      {
        this.change();
        $('#autocomplete').attr('placeholder','Enter Service Address and Select From Dropdown Below');
      
      }


  }  

  setChangedFormattedAddress() {
    this.ChangedformatedAddress = this.formatedAddress;
    if (
      this.apartment !== null &&
      this.apartment !== undefined &&
      this.apartment !== ''
    ) {
      this.ChangedformatedAddress = `${
        this.formatedAddress.split(',')[0]
      } APT ${this.apartment},${this.formatedAddress.split(',')[1]},${
        this.formatedAddress.split(',')[2]
      }`;
    }
  }
  changeIUsageGraphbyProduct(productObj) {
    var index = this.residentialService.recommendations.findIndex(
      (x) => x.ProductID === productObj.ProductID
    );
    this.graaphLabelName = this.assignEnergyProvidersLabelName(index);
    this.inializeFn();
    // this.onfreeze();
    // this.changeIUsageGraph(this.recommendations[index], index);
  }
  assignEnergyProvidersLabelName(i): any {
    return `${
      this.residentialService.recommendations[i].terms
    } ${this.residentialService.recommendations[
      i
    ].energy_provider.toUpperCase()}-${this.residentialService.recommendations[
      i
    ].product_key.toUpperCase()}`;
  }

  getProviderInfo() {
    this.residentialService
      .getProviderContactInfoDetails(
        this.selectedProduct.energy_provider,
        this.selectedProduct.utility_name
      )
      .subscribe((res: any) => {
        this.providerContact = res[0];
      });
  }

  navigateNewEnergyProvider() {
    window.location.href = `https://join.bulb.com/?utm_source=HonestGorilla&utm_medium=pcw&utm_campaign=HonestGorilla`;
  }

  beforeUnloadHandler() {
    if (!_.isEmpty(this.residentialService.user)) {


      var msg = 'Click the button below to see what energy plans Honest Gorilla is recommending for you. See much you could be saving on energy.';
      // const addressObj = _.findWhere(this.userResponses, {
      //   fieldName: 'address',
      // });
      // if(addressObj != undefined && addressObj != null ) {
      //   var formatted_address = addressObj.fieldValue.formatedAddress; 
      //   formatted_address = formatted_address.replace(", USA","");
      //   msg = "Complete your profile regarding "+formatted_address+" to see what energy plans Honest Gorilla is recommending for you."
  
      // }
      var a = this.getFormattedAddressByState_new(this.formatedAddress);
      if(this.formatedAddress != undefined && this.formatedAddress != null && a != '' ) {

        var formatted_address = this.formatedAddress.replace(", USA","");

        var unit = (a['apartment'] != ""  && a['apartment'] != undefined ?  a['apartment'] + ", " : "") ;
        var formatted_address__ = a['street_address'] + ", " + unit + a['city'] + ", " +  a['state'] + ", " + a['zipcode'];
     

        msg = "Click the button below to see what energy plans Honest Gorilla is recommending for you at "+formatted_address__+". See much you could be saving on energy."
    
      }

     

      const notificationObj = {
        type: 'enrollment_not_completed',
        hg_orders_id: '',
        hg_accountId:   this.residentialService.user &&
        this.residentialService.user._id === undefined
          ?  this.residentialService.user.accountId
          : this.residentialService.user._id,
        esiid: '',
        showNotification: true,
        isRead: false,
        navigation_link: null,
        userAddress: this.formatedAddress,
        buttonName: 'FINISH SHOPPING',
        buttonUrl: '/pre-success',
        order_no: '',
        questionnairePercent: 100,
        percentage: 100,
        title: "You're Almost Done",
        message:msg,
        createdBy: 0,
        lastUpdatedBy: 0,
        createdDate: this.residentialService.getServiceTypeDateObj(),
        lastUpdatedDate: this.residentialService.getServiceTypeDateObj(),
        processCompleted: false,
        StraigthPlanUserRequest : null
      };

      var user_object  = JSON.parse(sessionStorage.getItem('widthoutQuestionUserRequest'));
      if(user_object != null)
      {
        notificationObj.StraigthPlanUserRequest =user_object;
      }

      this.residentialService.updateNotificationObject(notificationObj);
    }
  }

  ngAfterViewInit(): void {
    const avgElements = document.getElementsByClassName('avgvalue');
    for (let i = 0; i < avgElements.length; i++) {
      if (avgElements[i].classList.contains('avgvalue')) {
        if (this.averagePrice.length >= 11 || this.avgbill.length >= 11) {
          avgElements[i].classList.add('avgpricelen22');
        } else if (
          this.averagePrice.length === 10 ||
          this.avgbill.length === 10
        ) {
          avgElements[i].classList.add('avgpricelen26');
        } else if (
          this.averagePrice.length === 9 ||
          this.avgbill.length === 9
        ) {
          avgElements[i].classList.add('avgpricelen30');
        } else if (
          this.averagePrice.length === 8 ||
          this.avgbill.length === 8
        ) {
          avgElements[i].classList.add('avgpricelen34');
        } else if (
          this.averagePrice.length === 7 ||
          this.avgbill.length === 7
        ) {
          avgElements[i].classList.add('avgpricelen38');
        } else if (this.averagePrice.length <= 6 || this.avgbill.length <= 6) {
          avgElements[i].classList.add('avgpricelen42');
        }
      }
    }
    this.checkState();
  }

  openEnergyRatesModal(template: ElementRef<any>) {
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: 'gray modal-small' })
    );
  }

  private productCodeFlag = true;
  energyRatesModalClose() {
    this.modalRef.hide();
  }

  markerIconUrl() {
    return require('../../../../assets/images/map-marker.png');
  }

  getFormattedAddress(place) {
    this.formatedAddress = place.formatted_address;

    this.newformateAddress = this.setNewFormattedAddress();
    let addressValue = '';
    for (let i = 0; i < place.address_components.length; i++) {
      const addressType = place.address_components[i].types[0];
      if (this.componentForm[addressType]) {
        const val =
          place.address_components[i][this.componentForm[addressType]];
        addressValue = addressValue + addressType + ':' + val + ';';
      }
      if (place.address_components[i].types[0] === 'postal_code') {
        this.zip_code = place.address_components[i].long_name;
      }
    }
    this.address = addressValue;
  }

  ngAfterViewChecked(): void {
    //Called after every check of the component's view. Applies to components only.
    //Add 'implements AfterViewChecked' to the class.
    const elem = document.getElementById(this.temperaryUtility);
    if (elem !== null && this.utilities.length === 1) {
      elem.classList.add('active-select');
    }
  }

  getOrderDetails(event) {
    if (event !== 'confirm_address') {
      this.orderDetails = true;
    } else {
      this.orderDetails = false;
    }
    if (event === 'enrollment') {
      this.showService = true;
    } else {
      this.showService = false;
    }
  }

  pad(number) {
    return (number < 10 ? '0' : '') + number;
  }

  getDetails(event) {
    if (event.startDate) {
      this.startDate =
        this.pad(new Date(event.startDate).getMonth() + 1) +
        '/' +
        new Date(event.startDate).getDate() +
        '/' +
        new Date(event.startDate).getFullYear();
    } else if (_.isEmpty(event.startDate) && event.selectedSwitch) {
      this.startDate = event.selectedSwitch;
    }
  }

  getInvoice(event) {
    this.showInvoice = event.agreeBoxes;
  }

  change() {
    var idddd = document.getElementById('autocomplete');
    idddd.classList.add('langColorpink12');
    var aptdiv = document.getElementById('aptdiv');
    aptdiv.classList.add('langColorpink12');
    this.disabled = false;
    this.esiidResponses = [];
    this.lookUpEsiID = '';
    this.enableESIDInput = false;
    this.disableButton = true;
    this.ngClass = false;
    this.billingAddress = false;
    this.selectedEsiid = '';
    this.city = '';
    this.state = 'TX';
    this.street_address = '';
    this.apt = '';
    this.zipcode = '';
    //this.esiid1 ='';

    localStorage.removeItem('currentEsiid');
    localStorage.removeItem('otherEsiid');
    this.isAddressChanged = true;
    this.selectedChange = true;
    this.apartment = '';
    this.ChangedformatedAddress = '';
    this.home_address = '';
    this.confirmFlag =false;
    this.isAddressSelected = false;


  }
  getState(event) {
    this.state = event;
  }
  help() {
    this.showHelp = true;
    this.residentialService.setHelpFlag({ flag: true });
    this.residentialService.loadScriptFiles('../../../../assets/js/custom.js');
  }

  confirm() {
    this.ServiceCompWeb = false;
    var idddd = document.getElementById('autocomplete');
    idddd.classList.remove('langColorpink12');
    var aptdiv = document.getElementById('aptdiv');
    aptdiv.classList.remove('langColorpink12');
    
    if (this.isAddressSelected) {
      this.confirmFlag = true;
      this.disabled = true;
      this.checkAddressSelected();
      this.esiidResponses = [];
      this.selectedEsiid = '';
      const hg_accountId = window.location.href.split('/').pop();
      if (_.isEmpty(this.residentialService.user.accountId))
        this.residentialService.user.accountId = hg_accountId;
      this.newformateAddress = this.setNewFormattedAddress();
      this.selectedEsiid = sessionStorage.getItem('esiidValue');
      this.display = 'block';
      this.isAddressChanged
        ? this.loadESIIDValuesPerAddress(
            this.formatedAddress,
            this.apartment,
            this.zip_code
          )
        : this.loadESIIDValuesPerAddress(
            this.oldAddress,
            this.oldApartment,
            this.oldZipCode
          );
    }
    else
    {
       var idddd = document.getElementById('autocomplete');
      idddd.classList.add('langColorpink12');
      var aptdiv = document.getElementById('aptdiv');
      aptdiv.classList.add('langColorpink12');
       this.confirmFlag = false;
    }
    this.nextButtonFlag = true;  
  }

  loadESIIDValuesPerAddress(address, apartment, zip_code) {
    let result;

    const signUpProduct =
    this.recommendationService.signupProduct !== undefined
      ? this.recommendationService.signupProduct
      : JSON.parse(sessionStorage.getItem('signupProduct'));
    
    var  utilityName = signUpProduct.utility_name;

    const body = new HttpParams()
      .append('hg_accountId', this.residentialService.user.accountId)
      .append('aptNo', apartment)
      .append('address', address)
      .append('postal_code', zip_code)
      .append('state', 'TX')
      .append('utility',utilityName);
    sessionStorage.removeItem('APIESIIDValues');
    sessionStorage.removeItem('esiidValue');
    this.selectedEsiid = '';
    this.residentialService
      .getUtilies(zip_code, address, apartment,utilityName)
      .subscribe((response: any) => {
        if (response.statusText === 'failed') {
          this.openNewEnergyRatesModal(this.noService);
          this.houseAddress1 = this.formatedAddress.split(',')[0];
          this.houseAddress2 = `${this.formatedAddress.split(',')[1]}, ${
            this.formatedAddress.split(',')[2]
          }, ${this.formatedAddress.split(',')[3]}`;
          this.display = 'none';
          this.home_address = '';
          this.ChangedformatedAddress = '';
          this.change();
        } else {

          if(!this.billingAddress)
          {
            $("#accept").trigger('click')
            
          }
          $('.addressFields').show();
          this.compareUtilityNames(response.data[0].Utility)
            ? this.loadESIIDValues(response.esidObj)
            : // ? this.loadUtilityBasedEsiid(body)
              this.setUtilities(response.data[0].Utility);
        }
      });
  }

  setUtilities(Utility: any) {
    this.utilities = Utility;
    this.openInvalidUtilityModal();
    this.display = 'none';
  }

  compareUtilityNames(utilityName) {
    return (
      this.selectedUtility ===
      this.actualUtilityName[this.renameProviderUtilityName(utilityName)]
    );
  }

  loadUtilityBasedEsiid(body) {
    this.http
      .get(this.url + '/esiid-data', { params: body })
      .subscribe((res: any) => {
        this.loadESIIDValues(res);
        sessionStorage.setItem('APIESIIDValues', res);
      });
  }

  renameProviderUtilityName(utilities) {
    return utilities.indexOf('(') !== -1
      ? utilities
          .substring(0, utilities.indexOf('('))
          .replace(/\s/g, '')
          .replace(/-/g, '')
      : utilities.replace(/\s/g, '');
  }

  loadEsiidUtilities() {
    var esiidString = sessionStorage.getItem('APIESIIDValues');
    if (esiidString) this.loadESIIDValues(esiidString.split(','));
  }

  setNewFormattedAddress(): any {
    let address = `${this.formatedAddress.split(',')[0]} ${this.apartment}${
      this.formatedAddress.split(',')[1]
    },${this.formatedAddress.split(',')[2]},${
      this.formatedAddress.split(',')[3]
    }`;
    if (this.apartment !== '') {
      address = `${this.formatedAddress.split(',')[0]} APT ${this.apartment}${
        this.formatedAddress.split(',')[1]
      },${this.formatedAddress.split(',')[2]},${
        this.formatedAddress.split(',')[3]
      }`;
    }
    return address;
  }

  checkAddressSelected() {
    this.formatedAddress !== this.oldAddress ||
    this.apartment !== this.oldApartment
      ? this.updateChangedAddress()
      : this.setUnchangedHomeAddress();
  }

  setUnchangedHomeAddress() {
    this.isAddressChanged = false;
    if (
      this.apartment != null &&
      this.apartment != '' &&
      this.apartment != undefined
    ) {
      this.home_address = this.formatedAddress + ', ' + this.apartment;
      this.home_address = this.ChangedformatedAddress;
    } else {
      this.home_address = this.formatedAddress;
    }
  }

  updateChangedAddress() {
    this.isAddressChanged = true;
    this.updateFormattedAddressResponse();
    const questionnaireStatusObj = this.residentialService
      .questionnaireStatusObj
      ? this.residentialService.questionnaireStatusObj
      : JSON.parse(sessionStorage.getItem('questionStatusObj'));
    this.residentialService.currentId = questionnaireStatusObj.questionStep;
    this.residentialService.setStatus('Completed');
    this.home_address = this.setHomeAddressFormatted(this.formatedAddress);
    this.ChangedformatedAddress = this.home_address;
    this.residentialService.updateResponsesOnly().subscribe((res: any) => {
      this.oldAddress = this.formatedAddress;
      this.oldApartment = this.apartment;
      this.oldZipCode = this.zip_code;
    });
  }

  setHomeAddressFormatted(formatedAddress): any {
    let address = formatedAddress;
    if (this.apartment !== '') {
      address = `${formatedAddress.split(',')[0]} APT ${this.apartment},${
        formatedAddress.split(',')[1]
      },${formatedAddress.split(',')[2]}`;
    }
    return address;
  }
  
  openInvalidUtilityModal() {
    this.modalRef = this.modalService.show(
      this.invalidUtility,
      Object.assign({}, { class: 'gray modal-small' })
    );
  }

    openInvalidinvalidESIIDModal(UtilityName) {
    this.UtilityText = UtilityName
    if(UtilityName != null)
    {
          if(UtilityName.toLowerCase() == "centerpoint")
          {
            this.UtilityNumber = '800-332-7143'
          }
          if(UtilityName.toLowerCase() == "oncor")
          {
            this.UtilityNumber = '888-313-6862'
          }
          if(UtilityName.toLowerCase() == "tnmp")
          {
            this.UtilityNumber = '888-866-7456'
            this.UtilityText = 'Texas-New Mexico Power';
          }

          if(UtilityName.toLowerCase() == "aepn" || UtilityName.toLowerCase() == "aepc")
          {
            this.UtilityText = 'AEP';
            this.UtilityNumber = ' 800-672-2231'
          }
    }
   
    this.modalRef = this.modalService.show(
      this.invalidESIID,
      Object.assign({}, { class: 'gray modal-small invalidEsiidPopup',  ignoreBackdropClick: true,
      keyboard: false })
    );
  }

  get sanitizedUtilityNumber(): string {
  return '1' + this.UtilityNumber?.replace(/-/g, '') || '';
  }

  closeInvalidUtilityTemplate() {
    this.home_address = '';
    this.ChangedformatedAddress = '';
    this.change();
    this.modalRef.hide();
  }

  getRecommendationsForNewUtility() {
    this.selectedUtility =
      this.actualUtilityName[this.renameProviderUtilityName(this.utilities)];
    this.updateFormattedAddressResponse();
    const questionnaireStatusObj = {
      questionStatus: 'Completed',
      questionStep: '0026',
      type: 'New Service',
      percentage: 100,
    };
    const user = {
      esiid: null,
      questionStatusObj: questionnaireStatusObj,
      questionnarieObj: JSON.parse(sessionStorage.getItem('userResponse')),
    };
    this.residentialService.getRecommendations(user).subscribe((result) => {
      this.recommendationService.recommendationObj =
        result['recommendedProduct'];
      sessionStorage.setItem(
        'recommendedProducts',
        JSON.stringify(result['recommendedProduct'])
      );
      this.newEnergyProviderRates();
    });
  }

  updateFormattedAddressResponse() {
    const Obj = {
      res_question_id: '008',
      fieldName: 'address',
      fieldValue: {
        address: this.address,
        formatedAddress: this.formatedAddress,
        apartment: this.apartment,
        geoMapAddress: this.geoMapAddress,
        utility: this.selectedUtility,
      },
    };
    this.residentialService.updateResponses(Obj);
    sessionStorage.setItem('formateAddress', JSON.stringify(Obj.fieldValue));
  }

  loadESIIDValues(result) {
    if (
      result === 'Requested data not found' ||
      result === '' ||
      result === 'Zip Code is Invalid' ||
      result === 'Addresses Not Found' ||
      result === 'Invalid address character' ||
      result === 'Zip code must be five digits long' ||
      result[0] === 'Requested data not found' ||
      result[0] === 'Zip code must be five digits long'
    ) {
      this.esiid_value = 'ESI ID # Locator  Currently Unavailable';
      this.selectedEsiid = 'ESI ID # Locator  Currently Unavailable';
      this.enableESIDInput = true;
      this.display = 'none';
    } else {
      if (result.length > 0 && result[0] != 'Requested data not found') {
        const value = this.concatenateAddressWithEsiid(result);
        this.esiidResponses = value;
        this.showCredits = '';
        this.enableESIDInput = false;

        if(this.selectedAddress != '')
        {
          this.selectedEsiid = this.selectedAddress;
          this.esiid_value = this.selectedAddress.split('-')[0];
          this.newFormattedAddress = this.selectedAddress.split('-')[1];
          this.residentialService.newFormattedAddress =
          this.selectedAddress.split('-')[1];

        }else
        {
          this.selectedEsiid = this.esiidResponses[0];
          this.esiid_value = this.esiidResponses[0].split('-')[0];
          this.newFormattedAddress = this.esiidResponses[0].split('-')[1];
          this.residentialService.newFormattedAddress =
          this.esiidResponses[0].split('-')[1];
        }
        



        
        this.residentialService.esiid = this.esiid_value;
        this.residentialService.tdspindicator = this.esiidTDSPIndicator[0].split('-')[1]
        this.residentialService.SWitchHoldindicator = this.esiidTSWitchHold[0].split('-')[1]

        this.formatedAddress = this.newFormattedAddress;
        this.ServiceCompWeb = true;
        sessionStorage.setItem('esiidValue', this.selectedEsiid);
        //sessionStorage.setItem('tdspIndicator', this.esiidTDSPIndicator[0].split('-')[1]);
      }
      this.checkEsiidExists();
      this.checkState();
      this.display = 'none';
    }
  }

  concatenateAddressWithEsiid(result: any) {
    const addressDetails: any = [];
    
    this.selectedAddress = '';
    result.map((res) => {
      if (res.Addresses) {


        const aa = res.Addresses.sort(function(a, b) {
          return b.Address1.localeCompare(a.Address1);
        });
      
        aa.reverse();

       

        aa.map((row) => {

          if(this.apartment != "" && this.apartment != null && aa.length > 1 && (row.Address1.toLowerCase().indexOf('apt ' + this.apartment) != -1 || row.Address1.toLowerCase().indexOf('rd ' + this.apartment) != -1 || row.Address1.toLowerCase().indexOf('ln ' + this.apartment) != -1  || row.Address1.toLowerCase().indexOf('#' + this.apartment) != -1  )) 
          {
            this.selectedAddress = `${row.ESIID}-${row.FullAddress}`;
            
          }

          addressDetails.push(`${row.ESIID}-${row.FullAddress}`);
          this.esiidTDSPIndicator.push(`${row.ESIID}-${row.TDSPIndicator}`)
          this.esiidTSWitchHold.push(`${row.ESIID}-${row.SwitchHoldIndicator}`)
        });
      }
    });

    if(this.selectedAddress != '')
    {
      const reordered = [this.selectedAddress, ...addressDetails.filter(num => num !== this.selectedAddress)];
      return reordered;
    }

    return addressDetails;

    // const addressDetails = [];
    // result[0].Addresses.map((row) => {
    //   addressDetails.push(`${row.ESIID}-${row.FullAddress}`);
    // });
    // return addressDetails;
  }

  getESIIDinputValue(event) {
    this.esiid1 = event;
    if (
      this.enableESIDInput === true &&
      !_.isEmpty(this.esiid1) &&
      this.validateBillingAddress == true
    ) {
      localStorage.setItem('currentEsiid', this.esiid1);
      localStorage.setItem('otherEsiid', this.esiid1);
      this.ngClass = true;
      this.disableButton = false;
      return false;
    } else {
      this.ngClass = false;
      this.disableButton = true;
      return true;
    }
  }

  getAccept(event) {
    // set the billing address selection in sessionstorage to save in orders collection
    this.billingAddress = event.target.checked;
    if (this.billingAddress === true) {
      this.billing_address = {
        billingAddress: this.getFormattedAddressByState(),
        apartment: this.apartment,
      };
      this.validateBillingAddress = true;
      this.street_address = '';
      this.city = '';
      this.state = 'TX';
      this.zipcode = '';
    } else {
      this.billing_address = {
        billingAddress: this.getBillingAddress(),
        apartment: this.apt,
      };
      this.validateBillingAddress = false;
    }
    const billAddress = {
      userAddress: this.getFormattedAddressByState(),
      apartment: this.apartment,
      billingAddress: this.billing_address,
      sameAsService: this.billingAddress,
    };
    sessionStorage.setItem('billingAddress', JSON.stringify(billAddress));
    this.checkState();
    if (
      this.selectedEsiid === null ||
      this.selectedEsiid === '' ||
      this.selectedEsiid === undefined
    ) {
      this.ngClass = false;
      this.disableButton = true;
      return true;
    }

    if(!this.billingAddress)
    {
      setTimeout(function(){

        $(".addressFields").show();

      },100)
    }

  }

  validate() {
    if (this.billingAddress === false) {
      if (
        this.street_address === undefined ||
        this.street_address === null ||
        this.street_address === '' ||
        this.city === undefined ||
        this.city === '' ||
        this.city === null ||
        this.state === '' ||
        this.state === null ||
        this.state === undefined ||
        this.zipcode === null ||
        this.zipcode === '' ||
        this.zipcode === undefined
      ) {
        this.validateBillingAddress = false;
      } else {
        this.validateBillingAddress = true;
        this.billing_address = {
          billingAddress: this.getBillingAddress(),
          apartment: this.apt,
        };
        const billAddress = {
          userAddress: this.getFormattedAddressByState(),
          apartment: this.apartment,
          billingAddress: this.billing_address,
          sameAsService: this.billingAddress,
        };
        sessionStorage.setItem('billingAddress', JSON.stringify(billAddress));
      }
    } else {
      this.validateBillingAddress = true;
    }
    this.checkState();
    if (this.nextButtonFlag) {
      this.disableButton = false;
    }
  }
  getFormattedAddressByState() {
    let temp_address = {};
    if (this.formatedAddress) {
      let address = this.formatedAddress.split(',');
      let [state, zipcode] = address[2] ? address[2].trim().split(' ') : '';
      if (address[0].indexOf('APT') > 1) {
        temp_address['street_address'] = address[0].substring(
          0,
          address[0].indexOf('APT') - 1
        );
        this.apartment = address[0].substring(address[0].indexOf('APT') + 4);
      } else {
        temp_address['street_address'] = address[0];
      }
      temp_address['city'] = address[1] ? address[1].trim() : '';
      temp_address['state'] = state ? state : '';
      temp_address['zipcode'] = zipcode ? zipcode : '';
    }
    return temp_address;
  }

  getBillingAddress() {
    return {
      street_address: this.street_address,
      city: this.city,
      state: this.state,
      zipcode: this.zipcode,
      country: 'USA',
    };
  }
  next(serviceTypeId,checked = null) {
    const accountId = this.recommendationService.hg_accountId;
    this.loadTdspNameForEsiid.map((row) => {
      if (row.key.toString() === this.selectedEsiid.substring(0, 7)) {
        this.selectedUtility = row.value;
      }
    });

    if(this.residentialService.SWitchHoldindicator == 'Y')
    {

      const elems = document.querySelectorAll('.active');
        if (elems !== null && this.deviceWidth < 768) {
          for (let i = 0; i < elems.length; ++i) {
            //if(elems[i].id != 'confirm_click' && elems[i].id !='confirm')
            //{
              elems[i].classList.remove('active');

            //}
          }

      const serviceTabValue = document.getElementById('service_click');
      serviceTabValue.classList.add('active');
      serviceTabValue.classList.add('nav-link');
      const serviceElementObj = document.getElementById(serviceTypeId);
      serviceElementObj.classList.remove('fade');
      serviceElementObj.classList.add('active');

        }

        this.ServiceCompWeb = false;

      this.openInvalidinvalidESIIDModal(this.selectedUtility)
       return;
    }

    this.recommendationService.signupProduct.utility_name =
      this.selectedUtility;
    this.selectedProduct = this.recommendationService.signupProduct;
    sessionStorage.setItem(
      'signupProduct',
      JSON.stringify(this.recommendationService.signupProduct)
    );



    this.residentialService.validateHGAccountID(accountId)
      ? this.submitOrderProductDetails(serviceTypeId)
      : this.moveToAddressConfirmation(serviceTypeId);

      if (this.userResponses == null && checked == 1) {
        //$("#StandardMoveIn").trigger('click')
      }


      if(serviceTypeId == "confirm" && this.deviceWidth < 768)
      {
        setTimeout(() => {
          $("#confirm456")[0].scrollIntoView();
        }, 1000);
    
      }

  }

  submitOrderProductDetails(serviceTypeId) {
    const signUpProduct =
      this.recommendationService.signupProduct !== undefined
        ? this.recommendationService.signupProduct
        : JSON.parse(sessionStorage.getItem('signupProduct'));
    const energyProviderName = signUpProduct.energy_provider,
      utilityName = signUpProduct.utility_name,
      planName = signUpProduct.product_key,
      productID = signUpProduct.ProductID;

    this.residentialService
      .getEnergyProvidersPlanStatus(energyProviderName, utilityName, planName)
      .subscribe(
        (res: any) => {
          if (
            res.length > 0 &&
            productID !== res[0].ProductID &&
            this.residentialService.validateCreatedDateTime(res[0].createdDate)
          ) {
            this.assignNewEnergyProvidersRates();
          } else {
            this.moveToAddressConfirmation(serviceTypeId);
          }
        },
        (err) => {
          this.moveToAddressConfirmation(serviceTypeId);
        }
      );
  }

  assignNewEnergyProvidersRates() {
    const user = {
      esiid: null,
      questionStatusObj: sessionStorage.getItem('questionStatusObj'),
      questionnarieObj: JSON.parse(sessionStorage.getItem('userResponse')),
    };
    this.residentialService.getRecommendations(user).subscribe((result) => {
      this.recommendationService.recommendationObj =
        result['recommendedProduct'];
      sessionStorage.removeItem('recommendedProducts');
      sessionStorage.setItem(
        'recommendedProducts',
        JSON.stringify(result['recommendedProduct'])
      );
      this.openNewEnergyRatesModal(this.newEnergyRates);
    });
  }

  moveToAddressConfirmation(serviceTypeId) {
    this.residentialService
      .postcreatelogdata({
        type: 'info',
        message: 'signuporder-addressconfirmation-step',
        data: this.selectedProduct,
      })
      .subscribe((res: any) => {});

    const elems = document.querySelectorAll('.active');
    if (elems !== null) {
      for (let i = 0; i < elems.length; ++i) {
        elems[i].classList.remove('active');
      }
    }
    const serviceTabValue = document.getElementById('service_click');
    serviceTabValue.classList.add('active');
    serviceTabValue.classList.add('nav-link');
    const serviceElementObj = document.getElementById(serviceTypeId);
    serviceElementObj.classList.remove('fade');
    serviceElementObj.classList.add('active');
    this.getOrderDetails('service_type');
    this.confirmDisable = true;
    // To load the component based on mobile width
    this.deviceWidth = window.innerWidth;
    if (this.deviceWidth > 768) {
    } else {
      this.showServiceComp = true;
    }
    // To save the billing address in enrollment
    const billAddress = {
      userAddress: this.getFormattedAddressByState(),
      billingAddress: this.billing_address,
      apartment: this.apartment,
      sameAsService: this.billingAddress,
    };
    this.residentialService
      .postcreatelogdata({
        type: 'info',
        message: 'signuporder-addressconfirmation-step',
        data: billAddress,
      })
      .subscribe((res: any) => {});
    sessionStorage.setItem('billingAddress', JSON.stringify(billAddress));

    if (this.esiid1 !== undefined) {
      localStorage.setItem('otherEsiid', this.esiid1);
    }
    var value = sessionStorage.getItem('esiidValue')
    var subString = value != null ? value.substring(value.length - 5) : "";
    
    var product = this.recommendationService.signupProduct;
    var emailId ="";
    if (
      !_.isEmpty(sessionStorage.getItem('userObj'))
    ) {
      emailId = JSON.parse(sessionStorage.getItem('userObj')).emailId
    }

    CallTrack_function(
      "SignupOrder",
      product.energy_provider, 
      product.product_key, 
      product.terms, 
      (product.tier[0].avg_charge * 100).toFixed(1),
      (product.tier[1].avg_charge * 100).toFixed(1),
      (product.tier[2].avg_charge * 100).toFixed(1),
      subString,  
      product.utility_name, 
      "", emailId );


  }

  openNewEnergyRatesModal(template: ElementRef<any>) {
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: 'gray modal-small' })
    );
  }

  newEnergyProviderRates() {
    sessionStorage.setItem(
      'currentUser',
      this.recommendationService.hg_accountId
    );
    this.modalRef.hide();
    this.router.navigate([
      'recommendation/compare-product',
      this.recommendationService.hg_accountId,
    ]);
  }

  // Back button functionality for signup-order Page.

  back() {
    this.loadSignUpOrderTabs();
  }

  loadSignUpOrderTabs() {
    const entroll = document.getElementById('enrollment');
    const serviceTab = document.getElementById('service');
    const serviceTabHeading = document.getElementById('service_click');
    if (entroll.classList.contains('active')) {
      if (this.showInvoice) {
        this.recommendationService.messageService({
          agreeBox: this.showInvoice,
        });
      } else {
        this.next('service',0);
      }
    } else if (serviceTab.classList.contains('active')) {
      serviceTab.classList.remove('active');
      serviceTab.classList.remove('nav-link');
      serviceTabHeading.classList.remove('active');
      const confirmTabValue = document.getElementById('confirm_click');
      confirmTabValue.classList.add('active');
      confirmTabValue.classList.add('nav-link');
      const confirmElementObj = document.getElementById('confirm');
      confirmElementObj.classList.remove('fade');
      confirmElementObj.classList.add('active');
      this.getOrderDetails('confirm_address');
    } else {
      this.router.navigate([
        'recommendation/compare-product',
        this.recommendationService.hg_accountId,
      ]);
    }
  }

  editnavigt(confmType) {
    const elemt = document.querySelectorAll('.active');
    if (elemt !== null) {
      for (let j = 0; j < elemt.length; ++j) {
        elemt[j].classList.remove('active');
      }
    }
    const confmTabValue = document.getElementById('confirm_click');
    confmTabValue.classList.add('active');
    const confirmEleObj = document.getElementById(confmType);
    confirmEleObj.classList.remove('fade');
    confirmEleObj.classList.add('active');
    this.getOrderDetails('confirm_address');
  }

  // to check the addresss and ESIId already exist or not
  checkEsiidExists() {
    this.esiid_value = this.selectedEsiid.split('-')[0];
    this.newFormattedAddress = this.selectedEsiid.split('-')[1];
    

    var list =  this.esiidTDSPIndicator.filter(x => x.split('-')[0] == this.esiid_value )
    if(list.length != 0)
    {
      this.residentialService.tdspindicator = list[0].split('-')[1]
      
    }

    var list =  this.esiidTSWitchHold.filter(x => x.split('-')[0] == this.esiid_value )
    if(list.length != 0)
    {
      this.residentialService.SWitchHoldindicator = list[0].split('-')[1]
     
    }

    
    this.residentialService.esiid = this.esiid_value;
    this.formatedAddress = this.newFormattedAddress;
    this.residentialService.newFormattedAddress =
      this.selectedEsiid.split('-')[1];
    sessionStorage.setItem('esiidValue', this.selectedEsiid);

    const body = new HttpParams()
      .append('userAddress', this.formatedAddress)
      .append('hg_accountId', this.recommendationService.hg_accountId)
      .append(
        'esiid',
        this.selectedEsiid ? this.esiid_value : this.lookUpEsiID
      );
    this.http
      .get(this.url + '/checkEsiid', { params: body })
      .subscribe((res: any) => {
        const result = res;
        if (this.residentialService.questionFlowType !== 'renewal') {
          if (result && result !== null) {
            if (this.esiid1) {
              localStorage.setItem('currentEsiid', this.esiid1);
            }
            this.validateEsiid = false;
            $('#esiidCheck').modal('show');
            this.modalRef.hide();
          } else {
            this.validateEsiid = true;
          }
        } else {
          this.validateEsiid = true;
        }
        this.checkState();
      });
  }

  checkState() {
    if (this.esiid1) {
      localStorage.setItem('currentEsiid', this.esiid1);
    }
    if (this.validateBillingAddress == true) {
      if (this.lookUpEsiID === true && this.esiid1 !== '') {
        this.enableNextButtonFlag();
        return false;
      } else if (this.lookUpEsiID && this.selectedEsiid !== '') {
        this.enableNextButtonFlag();
        return false;
      }
    } else {
      this.disableNextButtonFlag();
      return true;
    }

    if (this.billingAddress && this.lookUpEsiID && this.enableESIDInput) {
      this.enableNextButtonFlag();
    } else if (
      this.street_address &&
      this.city &&
      this.state &&
      this.zipcode &&
      this.enableESIDInput &&
      this.lookUpEsiID
    ) {
      this.enableNextButtonFlag();
    } else if (
      this.billingAddress &&
      this.selectedEsiid !== 'ESI ID # Locator  Currently Unavailable'
    ) {
      this.enableNextButtonFlag();
    } else if (
      this.street_address &&
      this.city &&
      this.state &&
      this.zipcode &&
      this.selectedEsiid !== 'ESI ID # Locator  Currently Unavailable'
    ) {
      this.enableNextButtonFlag();
    } else {
      this.disableNextButtonFlag();
    }
  }

  enableNextButtonFlag() {
    if (this.nextButtonFlag) {
      this.ngClass = true;
      this.disableButton = false;
    }
  }

  disableNextButtonFlag() {
    this.ngClass = false;
    this.disableButton = true;
  }

  send(event, myForm, formValid, modalId) {
    if (formValid) {
      this.modalRef.hide();
      this.contactObj.fullName = this.userObj.fullName;
      this.contactObj.emailId = this.userObj.emailId;
      this.contactObj.question = this.userObj.contactQues;
      const saveContactParam = new HttpParams().append(
        'contactObj',
        JSON.stringify(this.contactObj)
      );

      myForm.resetForm();
      const elementObj = document.getElementById(modalId);
      this.display = 'block';
      this.http
        .post(this.url + '/saveContact', saveContactParam)
        .subscribe((res: any) => {
          this.onCloseHandled();
          const saveContactResponse = res;
          this.modalRef.hide();
          this.openModal(this.thank);
        });
    }
  }

  closeContactModal(form) {
    this.modalRef.hide();
    form.resetForm();
  }

  closeResetModal() {
    this.modalRef.hide();
  }

  // to close the modal
  onCloseHandled() {
    this.display = 'none';
  }

  public handleAddressChange(address) {
    this.isAddressSelected = true;
    // this.geoMapAddress = address;
    // this.lng = address.geometry.location.lng;
    // this.lat = address.geometry.location.lat;
    // if (address) this.getFormattedAddress(address);

    this.geoMapAddress = address;
    // Set the geometry details in service -> To load the map

    if (typeof address.geometry.location.lng === 'number') {
      this.lng = address.geometry.location.lng;
      this.lat = address.geometry.location.lat;
    } else {
      this.lng = address.geometry.location.lng();
      this.lat = address.geometry.location.lat();
    }
    
    this.getFormattedAddress(address);


  }
  public onhandleAddressChange(address) {
    this.isAddressSelected = true;
    this.geoMapAddress = address;
    this.lng = address.geometry.location.lng;
    this.lat = address.geometry.location.lat;
    this.getFormattedAddress(address);
  }

  openModal(template: ElementRef<any>) {
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: 'gray modal-small' })
    );
  }

  closeModal() {
    this.modalRef.hide();
    this.openModal(this.contact);
  }

  setFlag(event) {
    this.isAddressSelected = false;
    this.callUtilityAPI = false;
  }

  selectUtility(utility) {
    this.temperaryUtility = utility;
    let existingElements = [];
    _.each(this.utilities, function (item) {
      existingElements.push(document.getElementById(item.Utility));
    });
    _.each(existingElements, function (item) {
      item.classList.remove('active-select');
    });
    const elem = document.getElementById(utility);
    elem.classList.add('active-select');
    if (
      this.selectedUtility !== this.temperaryUtility &&
      this.utilities.length === 1
    ) {
      this.msg =
        'Because products and pricing are utility-specific, you will now be redirected back to the recommendation page to make a new product selection.All of your other info will remain the same.';
    } else if (
      this.selectedUtility !== this.temperaryUtility &&
      this.utilities.length > 1
    ) {
      this.msg =
        'Thank you! Since your utility has changed, you will now be redirected back to the recommendation page to make a new product selection.';
    } else if (this.selectedUtility === this.temperaryUtility) {
      this.msg = 'Thank you! Your utility selection is saved.';
    }
    this.showMsg = true;
  }

  showText() {
    this.fullText = true;
    this.partialText = false;
  }
  partialText1() {
    this.fullText = false;
    this.partialText = true;
  }

  goRecommendations() {
    if (
      this.utilities.length > 0 &&
      this.selectedUtility !== this.temperaryUtility
    ) {
      this.selectedUtility = this.temperaryUtility;
      this.isAddressSelected = true;
      const Obj = {
        res_question_id: '008',
        fieldName: 'address',
        fieldValue: {
          address: this.address,
          formatedAddress: this.formatedAddress,
          apartment: this.apartment,
          geoMapAddress: this.geoMapAddress,
          utility: this.selectedUtility,
        },
      };
      const questionnaireStatusObj = this.residentialService
        .questionnaireStatusObj
        ? this.residentialService.questionnaireStatusObj
        : JSON.parse(sessionStorage.getItem('questionStatusObj'));
      this.residentialService.currentId =
        this.residentialService.questionnaireStatusObj.questionStep;
      this.residentialService.updateResponses(Obj);
      this.residentialService.setStatus('Completed');
      this.router.navigateByUrl('/pre-success');
      this.modalRef.hide();
    } else if (
      this.utilities.length > 0 &&
      this.selectedUtility === this.temperaryUtility
    ) {
      this.modalRef.hide();
      this.showMsg = false;
      this.isAddressSelected = true;
    } else {
      this.modalRef.hide();
      this.showMsg = false;
      this.isAddressSelected = false;
    }
  }

  selectedProductLogo() {
    return this.selectedProductLogos[
      this.selectedProduct.energy_provider.replace(/\s/g, '')
    ];
  }

  openDialog(singleObj) {
    this.showAll = !this.showAll;
    this.singleObj = singleObj;
    this.setSelectedPlanDetails(singleObj);
  }

  setSelectedPlanDetails(singleObj) {
    this.productKeyTitle = `${singleObj.energy_provider} - ${singleObj.product_key}`;
    this.productTitle = singleObj.energy_provider;
    this.avgCharge500 = Number(singleObj.tier[0].avg_charge * 100).toFixed(1);
    this.avgCharge1000 = (singleObj.tier[1].avg_charge * 100).toFixed(1);
    this.avgCharge2000 = (singleObj.tier[2].avg_charge * 100).toFixed(1);
    this.recommendedEnergyCharge = singleObj.energy_charge;
    if(singleObj.energy_provider == "4Change Energy")
    {
      this.recommendedEnergyCharge = Number(singleObj.energy_charge).toFixed(5);
      
    }
    if(singleObj.energy_provider == "Rhythm Energy" || singleObj.energy_provider == "APGE Energy" )
    {
      this.recommendedEnergyCharge = Number(singleObj.energy_charge).toFixed(5);
      
    }
    this.recommendedBaseFee = singleObj.base_fee !== null ? singleObj.base_fee : "0";
    this.recommendedBaseFee = this.recommendedBaseFee === "N/A" ? "0" : this.recommendedBaseFee;
    this.recommendedBaseFee = this.recommendedBaseFee === "0" ? "0.00" : this.recommendedBaseFee;
    if (singleObj.base_fee_limit) {
      this.recommendedBaseUsageLimit =
        singleObj.base_fee_limit.search('undefined') > 0
          ? `>=${singleObj.base_fee_limit.substring(
              0,
              singleObj.base_fee_limit.indexOf('undefined') - 1
            )}`
          : singleObj.base_fee_limit;
      this.recommendedBaseUsageLimit = ` for usage ${this.recommendedBaseUsageLimit} kWh`;
    }

    this.recommendedTduCharge = Number(singleObj.tdu_delivery_charge).toFixed(
      2
    );
    this.recommendedTduDeliveryCharge = singleObj.tdu_delivery_charge_per_kwh;
    this.averageMonthlyUsage = Math.round(singleObj.new_tier.ave_monthly_usage);
    this.avgPricePerKWH = Number(
      singleObj.new_tier.ave_price_per_KWH * 100
    ).toFixed(1);
    this.avgMonthlyBill = Number(singleObj.new_tier.ave_monthly_bill).toFixed(2);//= singleObj.new_tier.ave_monthly_bill;
    
    this.recommendedUsageCreditFee =
      singleObj.usage1Charge !== undefined ? singleObj.usage1Charge : 0;
    this.recommendedUsageCreditLimit = `${singleObj.usage1} - ${singleObj.usage2}`;
    this.monthlyEstimates = [
      Number(
        Number(singleObj.energy_charge * 500) +
          Number(singleObj.tdu_delivery_charge) +
          Number(singleObj.tdu_delivery_charge_per_kwh * 500)
      ).toFixed(2),
      Number(
        Number(singleObj.energy_charge * 1000) +
          Number(singleObj.tdu_delivery_charge) +
          Number(singleObj.tdu_delivery_charge_per_kwh * 1000)
      ).toFixed(2),
      Number(
        Number(singleObj.energy_charge * 2000) +
          Number(singleObj.tdu_delivery_charge) +
          Number(singleObj.tdu_delivery_charge_per_kwh) * 2000
      ).toFixed(2),
    ];
    // this.openNewEnergyRatesModal(this.planDetailsPopup);
  }

  showHighcharts() {
    this.toggleHighcharts = !this.toggleHighcharts;
  }

  inializeFn() {
    // for average amount change below gaph
    this.graphSelectedProduct = this.selectedProduct;
    this.avgMthlyUsage = Math.round(
      this.selectedProduct.new_tier.ave_monthly_usage
    );
    this.recommendationObj = JSON.parse(
      sessionStorage.getItem('recommendedProducts')
    );
    // For graph reset value and initial value -> while opening the edit
    this.monthlyUsageArr = this.recommendationObj.current_usage;
    if (this.avg_price_kwh != undefined) {
      let splitdata = this.avg_price_kwh.split('.');
      this.avg_price_kwh = splitdata[1];
    }
    // set that value in local storage to reset
    sessionStorage.setItem(
      'monthlyUsage_recommendation',
      JSON.stringify(this.recommendationObj)
    );

    // To get the old value
    this.oldValue = this.recommendationObj.current_usage.map(function (
      value,
      key
    ) {
      return {
        point: value.month,
        color: 'rgba(206,206,206,0.5)',
        avg_energy_charge_per_KWH: value.avg_energy_charge_per_KWH,
        y: Number(value.avg_energy_charge_per_KWH) * Number(value.usage),
        usage: Number(value.usage),
      };
    });

    // To change the color if the edit option is enabled
    let color = '#ffc214';
    if (this.showOption) {
      color = 'rgba(255, 194, 20,0.5)';
    }
    // recommended values
    if (this.updateProductChart === false) {
      this.newValue =
        this.recommendationObj.res_products_recommendations[0].monthly_usage.map(
          (value, key) => {
            return {
              point: value.month,
              color: color,
              avg_energy_charge_per_KWH: value.avg_energy_charge_per_KWH,
              y: value.avg_energy_charge_per_KWH,
              energy_charge_per_month: value.total_energy_charge_per_month
                ? value.total_energy_charge_per_month
                : 0,
              usage: value.usage,
            };
          }
        );
      for (let i = 0; i < this.oldValue.length; i++) {
        for (let j = 0; j < this.newValue.length; j++) {
          if (this.oldValue[i].point === this.newValue[j].point) {
            this.newValue[j].y = Math.round(
              Number(this.newValue[j].y) * Number(this.oldValue[i].usage)
            );
            // To change the selected bar color if it is in edit mode
            if (this.showOption && this.selectedIndex === j) {
              this.newValue[j].color = '#ffc214';
            }
          }
        }
      }
    } else {
      for (let i = 0; i < this.oldValue.length; i++) {
        for (let j = 0; j < this.newValue.length; j++) {
          if (this.oldValue[i].point === this.newValue[j].point) {
            this.newValue[j].y = Math.round(
              Number(this.newValue[j].energy_charge_per_month)
            );
            // To change the selected bar color if it is in edit mode
            if (this.showOption && this.selectedIndex === j) {
              this.newValue[j].color = '#ffc214';
            }
          }
        }
      }
    }
    this.loadHighChart();
  }

  // To load the highchart
  loadHighChart() {
    const self = this;
    // Left side highchart
    this.highChartsOptions = {
      chart: {
        renderTo: 'container',
        type: 'column',
        marginTop: 60,
      },
      xAxis: {
        gridLineWidth: 1,
        gridLineColor: '#e2e2e2',
        categories: [
          'Jan',
          'Feb',
          'Mar',
          'Apr',
          'May',
          'Jun',
          'Jul',
          'Aug',
          'Sep',
          'Oct',
          'Nov',
          'Dec',
        ],
        labels: {
          formatter: function (event) {
            // To show the total_energy_charge_per_month below month label in x-axis
            const series2Val = !_.isEmpty(self.visibleGraph)
              ? self.visibleGraph
              : self.highChartsOptions.series[1]
              ? self.highChartsOptions.series[1]
              : self.highChartsOptions.series[0];
            return (
              event.value +
              '<br>' +
              '$' +
              (!_.isEmpty(series2Val)
                ? Math.round(series2Val.data[event.pos].energy_charge_per_month)
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ',') +
                  '<br>' +
                  (self.highChartsOptions.series[1] != undefined
                    ? (
                        self.highChartsOptions.series[1].data[event.pos]
                          .avg_energy_charge_per_KWH * 100
                      ).toFixed(1) + '¢'
                    : (
                        self.highChartsOptions.series[0].data[event.pos]
                          .avg_energy_charge_per_KWH * 100
                      ).toFixed(1) + '¢')
                : Math.round(
                    self.highChartsOptions.series[0].data[event.pos]
                      .energy_charge_per_month
                  )
              )
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            );
          },
          autoRotation: false,
          style: {
            'font-family': 'Calibre',
            'font-size': '13px',
          },
        },
      },
       yAxis: [{ // Primary yAxis
        gridLineWidth: 1,
        gridLineColor: '#e2e2e2',
        title: false,

        labels: {
            format: '{value}¢',
           style: {
            'font-family': 'Calibre',
            'font-size': '13px',
            'color':'red'
          },
            enabled: false,
        }, 
        // title: {
        //     text: 'Avg Price in cents',
        //     style: {
        //     'font-family': 'Calibre',
        //     'font-size': '13px',
        //     'color':'red'
        //   },
        // }
    }, { // Secondary yAxis
        title: false,
        gridLineWidth: 0,
        // title: {
        //     text: 'Total Price in $',
        //     style: {
        //     'font-family': 'Calibre',
        //     'font-size': '13px',
        //     'color':'#ffc214'
        //   },
        // },
        labels: {
            format: '${value}',
            style: {
            'font-family': 'Calibre',
            'font-size': '13px',
            'color':'#ffc214'
          },
            enabled: false,
        },
        opposite: true
    }],
      // yAxis: {
      //   title: false,
      //   labels: {
      //     overflow: 'justify',
      //     enabled: false,
      //   },
      //   gridLineWidth: 0,
      // },
      plotOptions: {
        series: {
          // colorByPoint: true,
          cursor: 'pointer',
          point: {
            events: {
              click: function (event) {
                self.clicks++; // count clicks
                if (self.clicks === 1) {
                  self.timer = setTimeout(function () {
                    self.clicks = 0; // after action performed, reset counter
                    if (
                      self.selectedIndex !== event.point.index &&
                      event.point.color === 'rgba(255, 194, 20,0.5)'
                    ) {
                      self.updateChart(event);
                    } else {
                      self.clicks = 0; // after action performed, reset counter
                    }
                  }, self.DELAY);
                } else {
                  clearTimeout(self.timer); // prevent single-click action
                  // To reset the color for already selected bar
                  if (!_.isEmpty(self.highChartsOptions.series[1])) {
                    self.highChartsOptions.series[1].data[
                      self.selectedIndex
                    ].color = 'rgba(255, 194, 20,0.5)';
                  } else {
                    self.highChartsOptions.series[0].data[
                      self.selectedIndex
                    ].color = 'rgba(255, 194, 20,0.5)';
                  }
                  // Changing the current Index as selected index
                  self.selectedIndex = event.point.index;
                  self.monthName = event.point.point;

                  // Calculating the updatedNewValue if the monthly usage is changed
                  self.updatedNewValue =
                    self.oldValue[self.selectedIndex].usage;

                  // To check the value is changed or not
                  document.getElementById('editValue')['value'] =
                    self.updatedNewValue;
                  const elem =
                    document.getElementsByClassName('highcharts-tooltip');
                  const tooltipElem =
                    document.getElementsByClassName('updatept');
                  tooltipElem[0]['style'].top = elem[1]['style'].top;
                  tooltipElem[0]['style'].left = elem[1]['style'].left;

                  if (!_.isEmpty(self.highChartsOptions.series[1])) {
                    self.highChartsOptions.series[1].data[
                      self.selectedIndex
                    ].color = '#ffc214';
                  } else {
                    self.highChartsOptions.series[0].data[
                      self.selectedIndex
                    ].color = '#ffc214';
                  }
                  self.updateValue = true;
                  self.clicks = 0; // after action performed, reset counter
                }
              },
            },
          },
          pointWidth: self.pointWidth,
          events: {
            legendItemClick: function (e) {
              const visibility = this.visible ? 'visible' : 'hidden';
              if (_.isEmpty(self.highChartsOptions.series[1])) {
                // new service -> so restrict the click action
                e.preventDefault();
              } else {
                const chart = this.chart;
                const index = this.index;
                let atleastOneVisible = false;
                // assign the visible graph to change the x-axis label on legend click
                $.each(chart.series, function (i, serie) {
                  if (serie.visible && serie.index !== index) {
                    atleastOneVisible = true;
                    self.visibleGraph =
                      self.highChartsOptions.series[serie.index];
                  }
                });
                // if both are visible then choose the new value

                if (
                  atleastOneVisible &&
                  ((chart.series[0].visible === false &&
                    chart.series[1].visible === true) ||
                    (chart.series[1].visible === false &&
                      chart.series[0].visible === true))
                ) {
                  self.visibleGraph = self.highChartsOptions.series[1];
                } else {
                  // before this code is not written here . --siva j
                  self.visibleGraph = self.highChartsOptions.series[0];
                }
                // to show atleast one legend
                if (!atleastOneVisible) {
                  e.preventDefault();
                } else {
                  self.updateValue = true;
                }
              }
            },
          },
        },
        column: {
          pointWidth: 20,
          groupPadding: 0.5,
        },
      },
      tooltip: {
        style: {
          pointerEvents: 'all',
        },
        useHTML: true,
        formatter: function (event) {
          // To show the tooltip with current usage value
          let tooltipHTML = this.x;
          const series2Val = self.highChartsOptions.series[1];
          // if (!_.isEmpty(series2Val)) {
          //   tooltipHTML =
          //     '<div class="chart_tool_tip">' +
          //     this.x +
          //     '<span class="d-block">' +
          //     Math.round(
          //       self.highChartsOptions.series[0].data[this.point.index].usage
          //     )
          //       .toString()
          //       .replace(/\B(?=(\d{3})+(?!\d))/g, ',') +
          //     '</span>' +
          //     '</div>';
          //   return tooltipHTML;
          // } else {
          //console.log(self.oldValue[this.point.index])
          //console.log(self.highChartsOptions.series[0].data[this.point.index])
          
            tooltipHTML =
              '<div class="chart_tool_tip">' +
              '<span class="d-block">' +
              this.x + ' ' + 
              Math.round(self.oldValue[this.point.index].usage)
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ',') + " kWh at "+  Number((self.highChartsOptions.series[0].data[this.point.index].avg_energy_charge_per_KWH * 100 ).toFixed(1)) +"¢"
              '</span>' +
              '</div>';
            return tooltipHTML;
        //  }
        },
      },
      // tooltip: {
      //   style: {
      //     pointerEvents: 'all',
      //   },
      //   useHTML: true,
      //   formatter: function (event) {
      //     // To show the tooltip with current usage value
      //     let tooltipHTML = this.x;
      //     const series2Val = self.highChartsOptions.series[1];
      //     if (!_.isEmpty(series2Val)) {
      //       tooltipHTML =
      //         '<div class="chart_tool_tip">' +
      //         this.x +
      //         '<span class="d-block">' +
      //         Math.round(
      //           self.highChartsOptions.series[0].data[this.point.index].usage
      //         )
      //           .toString()
      //           .replace(/\B(?=(\d{3})+(?!\d))/g, ',') +
      //         '</span>' +
      //         '</div>';
      //       return tooltipHTML;
      //     } else {
      //       tooltipHTML =
      //         '<div class="chart_tool_tip">' +
      //         this.x +
      //         '<span class="d-block">' +
      //         Math.round(self.oldValue[this.point.index].usage)
      //           .toString()
      //           .replace(/\B(?=(\d{3})+(?!\d))/g, ',') +
      //         '</span>' +
      //         '</div>';
      //       return tooltipHTML;
      //     }
      //   },
      // },
      title: {
        text: null,
      },
      credits: {
        enabled: false,
      },
      legend: {
        layout: 'vertical',
        align: 'left',
        verticalAlign: 'top',
        floating: true,
        x: 0,
        y: 0,
        backgroundColor: '#FFFFFF',
        shadow: false,
        useHTML: true,
        margin: 100,
        itemDistance: 50,
        itemMarginTop: -20,
        itemMarginBottom: 20,
        itemStyle: {
          color: '#000000',
          fontWeight: 'normal',
          fontSize: '14px',
          fontFamily: 'Calibre',
        },
        symbolRadius: 0,
        labelFormatter: function (event) {
          return this.name;
        },
      },
      lang: { thousandsSep: ',' },
      series: [
        {
          name: this.graaphLabelName
            ? this.graaphLabelName
            : 'New 12 Months Rate',
          data: this.newValue,
          color: '#ffc214',
        },
      ],
    };
     var reats = this.newValue;
    var newRates = this.getAvgRates(reats);
    // To check 'New Service' and 'Switching providers'
    if (this.recommendationObj.service_type !== 'Switching Providers') {
        this.highChartsOptions.series = [
         {

          name: this.graaphLabelName
            ? this.graaphLabelName + " Total Price"
            : 'New 12 Months Rate',
          data: this.newValue,
          color: '#ffc214',
          yAxis: 1
        },
        {
          type: 'line',
          name: this.graaphLabelName
            ? this.graaphLabelName + " Average Price"
            : 'New 12 Months Rate',
          data: newRates,
          color: '#ED1976',
        },
       
      ];
      // to disable the legend hover
      this.highChartsOptions.legend.itemStyle = {
        color: '#000000',
        fontWeight: 'normal',
        fontSize: '14px',
        fontFamily: 'Calibre',
        cursor: 'default',
      };
      this.updateValue = true;
    }
    if (window.screen.availWidth < 595) {
      this.highChartsOptions.plotOptions.series.pointWidth = 22;
    } else {
      this.highChartsOptions.plotOptions.series.pointWidth = 35;
    }
  }
  updateChart(event) {
    const value = Number(this.updatedNewValue);
    let updatedMonth;

    // Check the type and assign the data value
    if (!_.isEmpty(this.highChartsOptions.series[1])) {
      this.highChartsOptions.series[1].data[this.selectedIndex].y =
        value *
        Number(
          this.highChartsOptions.series[1].data[this.selectedIndex]
            .avg_energy_charge_per_KWH
        );
      this.highChartsOptions.series[1].data[this.selectedIndex].color =
        '#ffc214';
      updatedMonth =
        this.highChartsOptions.series[1].data[this.selectedIndex].point;
    } else {
      this.highChartsOptions.series[0].data[this.selectedIndex].y =
        value *
        Number(
          this.highChartsOptions.series[0].data[this.selectedIndex]
            .avg_energy_charge_per_KWH
        );
      this.highChartsOptions.series[0].data[this.selectedIndex].color =
        '#ffc214';
      updatedMonth =
        this.highChartsOptions.series[0].data[this.selectedIndex].point;
    }

    // To update the usage and get the recommendation value from backend
    // To update the usage object with the updated value
    // let valueUpdated = false;
    // if (
    //   Number(this.recommendationObj.current_usage[this.selectedIndex].usage) !==
    //   Number(value)
    // ) {
    //   this.recommendationObj.current_usage[this.selectedIndex].usage =
    //     Number(value);
    //   valueUpdated = true;
    // }

    // this.clicks = 0; // after action performed, reset counter
    // if (valueUpdated) {
    //   this.openModal();
    //   const res_usage = {
    //     usage_history: this.recommendationObj.current_usage,
    //     service_type: this.recommendationObj.service_type,
    //     hg_accountId: this.recommendationObj.hg_accountId,
    //     avg_price_kwh:
    //       this.recommendationObj.current_usage[0].avg_energy_charge_per_KWH,
    //   };
    //   const body = new HttpParams().append(
    //     'userResponses',
    //     JSON.stringify(res_usage)
    //   );

    //   this.http
    //     .post(this.url + '/updateRecommendation', body)
    //     .subscribe((res: any) => {
    //       this.updateRecommendationValues(res);
    //       this.inializeFn();
    //       setTimeout(() => {
    //         this.onCloseHandled();
    //       }, 3500);
    //     });
    // } else {
    //   this.inializeFn();
    // }
  }
  // private updateRecommendationValues(res: Response) {
  //   const result = res;
  //   this.recommendationObj = result;
  //   sessionStorage.setItem(
  //     'recommendedProducts',
  //     JSON.stringify(this.recommendationObj)
  //   );
  //   this.recommendationService.recommendationObj = this.recommendationObj;
  //   this.applyRecommendationFilters();
  // }

  // private applyRecommendationFilters() {
  //   this.recommendations = [];
  //   this.assignPreRecommendationValues();
  //   if (this.splitData.length > 1) {
  //     this.prerecommendation = _.uniq(this.recommendations, function (value) {
  //       return value.terms.toString() && value.energy_provider;
  //     });
  //   } else {
  //     this.prerecommendation = this.recommendations;
  //   }
  //   if (this.swipedId === undefined) this.swipedId = this.productIndex;
  //   this.assignActiveClassToRecommendProduct();
  //   this.graphSelectedProduct = this.recommendations[this.productIndex];
  //   this.updateProductChart = true;
  //   this.changeBarChart(this.graphSelectedProduct);
  //   this.changeIUsageGraph(
  //     this.recommendations[this.productIndex],
  //     this.productIndex
  //   );
  // }
  
  removeminus(input) {
    var str = "" + input;

    if(str !== null && str != "")
    {
      var matches = str.match(/(\d+)/);
      
      if (matches) {
          return "$"+ matches[0];
      }
   
    }

return "$" + input;
}

getFormattedAddressByState_new(address) {
  let temp_address = {};
  try{
     
  let address_ = address;
  if (address_ != "" && address_ != "undefined") {
    let address = address_.split(',');
    let [state, zipcode] = address[2] ? address[2].trim().split(' ') : '';
    if (address[0].toUpperCase().indexOf('APT') > 1) {
      temp_address['street_address'] = address[0].substring(
        0,
        address[0].toUpperCase().indexOf('APT') - 1
      );
      temp_address['apartment'] = address[0].substring(address[0].toUpperCase().indexOf('APT') + 4);
    } else {
      temp_address['street_address'] = address[0];
      temp_address['apartment'] = this.apartment;
    }
    temp_address['city'] = address[1] ? address[1].trim() : '';
    temp_address['state'] = state ? state : '';
    temp_address['zipcode'] = zipcode ? zipcode : '';
  }
  return temp_address;
}catch{
    
     
  return '';


}


}

loadScript() {
  let node = document.createElement('script'); // creates the script tag
  node.src = 'https://www.googletagmanager.com/gtag/js?id=AW-10999221905'; // sets the source (insert url in between quotes)
  // node.type = 'text/javascript'; // set the script type
  node.async = true; // makes script run asynchronously
  // node.charset = 'utf-8';
  // append to head of document
  
  document.getElementsByTagName('head')[0].appendChild(node); 

  let script = this._renderer2.createElement('script');
  script.setAttribute('id', 'ChatScript');
  script.text = `
      (function(d, w, c) {
        w.BrevoConversationsID = '649dacacdbc74231a94a3297';
        w[c] = w[c] || function() {
            (w[c].q = w[c].q || []).push(arguments);
        };
        var s = d.createElement('script');
        s.async = true;
        s.src = 'https://conversations-widget.brevo.com/brevo-conversations.js';
        if (d.head) d.head.appendChild(s);
    })(document, window, 'BrevoConversations');
  `;

  const existingScript = document.getElementById("ChatScript");


  if (!existingScript) {
    
  document.getElementsByTagName('head')[0].appendChild(script); 
  }
}

getAvgRates(newValue)
{
  var newArray = [];
  
    for (let j = 0; j < newValue.length; j++) {
          var r = {
          point: newValue[j].point,
          color: '#ED1976',
          avg_energy_charge_per_KWH: newValue[j].avg_energy_charge_per_KWH,
          y: Number((newValue[j].avg_energy_charge_per_KWH * 100 ).toFixed(1)),
          energy_charge_per_month: newValue[j].energy_charge_per_month,
          usage: newValue[j].usage,
          }

          newArray.push(r)

    }
        
 
  return newArray;
}



formatEsiid(esiid: string): string {
  if (!esiid || !esiid.includes('-')) return esiid;

  const parts = esiid.split('-');
  return `${parts[1]}-${parts[0]}`; // ABC-123
}

getRenewableValue(value: any): number {
  if (value == null || value === '') return 0;
  return +value; // converts string/number to number
}

}
